import styles from "@@/styles/components/header/Dropdown.module.scss";

import { useHeaderCategoryContext } from "@@/hooks/contexts/headerCategroyContext";

import DropdownContent from "./DropdownContent";
import {JSX} from "react";

interface IDropDownProps {
	scrollTop: boolean
}

export default function Dropdown(props: IDropDownProps): JSX.Element {
	const { scrollTop, } = props;
	const { setHoveredCategory, } = useHeaderCategoryContext();

	function closeHandler() {
		setHoveredCategory(undefined);
	}

	return (
		<div className={`${styles.container}`}>
			<div className={styles.background} onMouseEnter={closeHandler}></div>

			<div
				className={`${styles.main} px-11`}
				style={{ marginTop: scrollTop ? "" : "5rem", }}
			>
				<DropdownContent />
			</div>
		</div>
	);
}
